export const getLocalStorage = (key) => {
  const getData = localStorage.getItem(key);
  const parseData = JSON.parse(getData);

  return parseData;
};

export const setLocalStorage = (key, value) => {
  // removeLocalStorage(key);

  const stringifyValue = JSON.stringify(value);
  localStorage.setItem(key, stringifyValue);
};

export const removeLocalStorage = (key) => {
  localStorage.removeItem(key);
};

export const ClearLocalStorage = () => {
  localStorage.clear();
};

export const getItem = (key) => {
  return localStorage.getItem(key);
};

export const removeLenderFilterItems = ({ applicationId, fieldKey }) => {
  const raw = localStorage.getItem("productLenderFilters");
  if (!raw) return; // nothing stored

  let data;
  try {
    data = JSON.parse(raw);
  } catch (e) {
    return;
  }

  // check if main object exists
  if (!data?.[applicationId]?.[fieldKey]) return;

  // set empty array
  data[applicationId][fieldKey] = [];

  // save updated object back
  localStorage.setItem("productLenderFilters", JSON.stringify(data));
};